import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NormalizeRouteCase from "./normalizeRouteCase";
import { ConversationProvider } from "@elevenlabs/react";

import "./App.css";

import StartPage from "./page/star-enterprise/startpage/startpage";
import HomePage from "./page/star-enterprise/homepage/homepage";
import Test from "./page/star-enterprise/homepage/testUseWhisper"; //test only
import HospitalStartPage from "./page/hospital/startpage/startpage";
import HospitalHomePage from "./page/hospital/homepage/homepage";
import ClassroomStartPage from "./page/classroom/startpage/startpage";
import ClassroomHomePage from "./page/classroom/homepage/homepage";
import LandingPage from "./page/landing-page/landingPage";
import VideoTest from "./page/star-enterprise/homepage/videoTest";
import EndpointTest from "./page/star-enterprise/homepage/endpointTest";

function StarEnterpriseWrapper() {
  return (
    <ConversationProvider>
      <HomePage />
    </ConversationProvider>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <NormalizeRouteCase>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/star-enterprise" element={<StartPage />} />
            <Route path="/:avatar" element={<StarEnterpriseWrapper />} />
            <Route path="/avatar/:avatar" element={<StarEnterpriseWrapper />} />
            <Route path="/test-whisper" element={<Test />} />
            <Route path="/hospital" element={<HospitalStartPage />} />
            <Route path="/hospital/:avatar" element={<HospitalHomePage />} />
            <Route path="/classroom" element={<ClassroomStartPage />} />
            <Route path="/classroom/:avatar" element={<ClassroomHomePage />} />
            <Route path="/video-test" element={<VideoTest />} />
            <Route path="/endpoint-test" element={<EndpointTest />} />
          </Routes>
        </NormalizeRouteCase>
      </div>
    </Router>
  );
}

export default App;

